/**
 * Kanonik URL va og:image uchun sayt ildizi.
 * Prod: REACT_APP_PUBLIC_SITE_URL=https://addegroup.uz — ixtiyoriy; bo‘lmasa window.location.origin.
 */
export function getPublicSiteOrigin(): string {
  try {
    const raw =
      typeof process !== 'undefined' && process.env && process.env.REACT_APP_PUBLIC_SITE_URL
        ? String(process.env.REACT_APP_PUBLIC_SITE_URL).trim()
        : '';
    if (raw) {
      return raw.replace(/\/+$/, '');
    }
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/+$/, '');
  }
  return 'https://addegroup.uz';
}

export function buildCanonicalUrl(pathname: string, search: string): string {
  const origin = getPublicSiteOrigin();
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const q = search && search !== '?' ? search : '';
  return `${origin}${path}${q}`;
}
